import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import ActionButton from "../components/ActionButton";
import PanelGroupController from "../components/PanelGroupController";
import PanelHeaderItem from "../components/PanelHeaderItem";
import FilterPanel from "../components/panels/FilterPanel";
import MigrationList from "./views/MigrationList";
import MigrationPropertiesPanel from "./panels/MigrationPropertiesPanel";
import {withApollo} from "react-apollo";
import {fromJS, List} from "immutable";

const statusFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "completed", label: "Completed"},
  {id: "prepared", label: "Prepared"}
])

const subscriptionFilterOptions = fromJS([
  {id: "", label: "Any"},
  {id: "active", label: "Active"},
  {id: "none", label: "None"}
])


class MigrationsPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.state = {
      customerId: "",
      hasCustomerSelection: false,
      statusFilter: "prepared",
      subscriptionFilter: ""
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Migrations";

    return (
      <div className="SalesPage MigrationsPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem show={true} label="Properties" id="general" selectedId="general" onClick={this.handlePanelItemSelection.bind(this)} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Change password" 
              active={this.state.hasCustomerSelection}
              onClick={this.handleChangePassword.bind(this)} />          
          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderView(page) {
    switch(page) {
      case "migrations":
        return (
          <MigrationList
            selectedCustomerId={this.state.customerId} 
            onSelectionChange={this.handleSetSelection}
            statusFilter={this.state.statusFilter}
            subscriptionFilter={this.state.subscriptionFilter}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }

  renderPanels(page) {
    switch(page) {
      default:
        return this.buildPanels(List(["statusFilter", "subscriptionFilter", MigrationPropertiesPanel]));
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case MigrationPropertiesPanel:
        if (!this.state.hasCustomerSelection) return null;
        return <MigrationPropertiesPanel key="MigrationPropertiesPanel" customerId={this.state.customerId} />

      case "statusFilter":
        return <FilterPanel
          key="StatusFilterPanel"
          title="Status Filter"
          expanded={true}
          options={statusFilterOptions}
          onClick={this.handleSetStatusFilter.bind(this)}
          filter={this.state.statusFilter}
          />        

      case "subscriptionFilter":
        return <FilterPanel
          key="SubscriptionFilterPanel"
          title="Active Subscriptions"
          expanded={true}
          options={subscriptionFilterOptions}
          onClick={this.handleSetSubscriptionFilter.bind(this)}
          filter={this.state.subscriptionFilter}
          />        

      default:
        return null;      
    }
  } 


  handlePanelItemSelection(id) {
    // do nothing
  }  

  handleSetStatusFilter(item) {
    this.setState({
      statusFilter: item.get("id")
    });
  }    

  handleSetSubscriptionFilter(item) {
    this.setState({
      subscriptionFilter: item.get("id")
    });
  }    

  handleSetSelection(id) {
    this.setState({customerId: id, hasCustomerSelection: true});
  }

  handleChangePassword() {
    this.props.requestChangePassword(this.state.customerId);
  }

}

export default withApollo(MigrationsPage);